import appLocaleData from 'react-intl/locale-data/en';

const enLang = {
  messages: {
    ...(window as any).RBH_MESSAGE_EN,
  },
  locale: 'en-US',
  data: appLocaleData,
};

export default enLang;
